import styled from "styled-components";
import { InputWrapper } from "../../../input/styled.js";
export const CalendarMobileInputWrapper = styled.div.withConfig({
    displayName: "styled__CalendarMobileInputWrapper",
    componentId: "sc-f37bb4bc-0"
})`
	cursor: pointer;
	width: 100%;

	&.calendar-range-input {
		width: 50%;
	}

	${InputWrapper} {
		pointer-events: none;
	}
`;

//# sourceMappingURL=styled.js.map